import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D3EFEC",
      "fill-rule": "evenodd",
      d: "M12.987 7a6.4 6.4 0 1 1-12.8 0 6.4 6.4 0 0 1 12.8 0m-5.6-3.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0m-1.6 2.4a.8.8 0 1 0 0 1.6v2.4a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 0-1.6V7a.8.8 0 0 0-.8-.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }